// extracted by mini-css-extract-plugin
module.exports = {"button":"CharacterSheetTweaker_button_3BkJ6","label":"CharacterSheetTweaker_label_22jN0"};